import { RegistrationType } from 'features/call/call-deaf/enums';

export function isSorensonRegistrationType(type: RegistrationType): boolean {
  return (
    type === RegistrationType.Sorenson ||
    type === RegistrationType.Emergency ||
    type === RegistrationType.Provisional
  );
}
